import gql from 'graphql-tag';

export const hierarchyTransferCreate = gql`
  mutation hierarchyTransferCreate($input: HierarchyTransferCreateInput!) {
    hierarchyTransferCreate(input: $input) {
      hierarchy_transfer {
        id
      }
    }
  }
`;

export const hierarchyOwnerPurchasedIdentityCreate = gql`
  mutation hierarchyOwnerPurchasedIdentityCreate(
    $input: HierarchyOwnerPurchasedIdentityCreateInput!
  ) {
    hierarchyOwnerPurchasedIdentityCreate(input: $input) {
      hierarchy_owner_purchased_identity {
        id
        album {
          id
        }
        album_folder {
          id
        }
        identity {
          id
        }
        grantor {
          id
        }
      }
    }
  }
`;
